import { cn } from '@/utils/cn';
import type { ReactNode } from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info';

const variants: Record<BadgeVariant, string> = {
  default: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  success: 'bg-success-50 text-success-700 dark:bg-emerald-950/40 dark:text-emerald-400',
  warning: 'bg-warning-50 text-warning-800 dark:bg-amber-950/40 dark:text-amber-400',
  error: 'bg-error-50 text-error-700 dark:bg-red-950/40 dark:text-red-400',
  info: 'bg-primary-50 text-primary-700 dark:bg-primary-950/40 dark:text-primary-300',
};

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium',
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
